const getAppName = (env: NodeJS.ProcessEnv = process.env): string => {
  const appName = env.APP_NAME?.trim()
  if (!appName) {
    throw new Error("Missing APP_NAME")
  }
  return appName
}

export const GLOBAL_DB_SUFFIX = "-global-db"

export const getGlobalDbName = (env: NodeJS.ProcessEnv = process.env): string => {
  return `${getAppName(env)}${GLOBAL_DB_SUFFIX}`
}

export const getTenantDbName = (tenantId: string, env: NodeJS.ProcessEnv = process.env): string => {
  return `${getAppName(env)}-${tenantId.trim()}-db`
}
